export * from "-!../../../../node_modules/babel-loader/lib/index.js!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./FreightFiles.vue?vue&type=template&id=70ffc972"


//////////////////
// WEBPACK FOOTER
// ./src/pages/Purchases/Freight/FreightFiles.vue?vue&type=template&id=70ffc972
// module id = 2307
// module chunks = 31